/**
 * Factory: QueryStringBuilder
 */
angular.module('acme.common.factory.QueryStringBuilder', [])
.factory('QueryStringBuilderFactory', [function() {


  function QueryStringBuilder(config) {
    if (config) {
      this.init(config);
    }
  }

  QueryStringBuilder.prototype = {

    constructor: QueryStringBuilder,

    q: [],
    paths: [],
    query: '',
    properties: {},

    init: function(config) {

      var r = true;

      this.reset();

      if (config.hasOwnProperty('props')) {

        this.properties = config.props;

        if (config.hasOwnProperty('fields')) {

          if (config.fields.hasOwnProperty('requires')) {
            r = this.addRequired(config.fields.requires);
          }

          if (config.fields.hasOwnProperty('optional')) {
            this.addOptional(config.fields.optional);
          }

          if (config.fields.hasOwnProperty('paths')) {
            this.addPaths(config.fields.paths);
          }

        }

        if (r) {
          if (this.build()) {
            r = this.query;
          }
        }

      }else{

        r = false;

      }

      return r;

    },

    reset: function() {
      this.q = [];
      this.paths = [];
      this.query = '';
      this.properties = {};
    },

    build: function() {
      var r = false;
      if (this.q.length > 0) {
        this.query = this.getPath() + this.getQuery();
        r = true;
      }
      return r;
    },

    addRequired: function(list) {
      var i, ii,
          r = true;

      for (i=0,ii=list.length;i<ii;i++) {
        if (this.properties.hasOwnProperty(list[i]) && this.properties[list[i]]) {
          this.q.push(list[i] + '=' + encodeURIComponent(this.properties[list[i]]));
        }else{
          r = false;
          this.q = [];
          break;
        }
      }
      return r;
    },

    addOptional: function(list) {
      var i, ii;

      for (i=0,ii=list.length;i<ii;i++) {
        if (this.properties.hasOwnProperty(list[i]) && this.properties[list[i]]) {
          this.q.push(list[i] + '=' + encodeURIComponent(this.properties[list[i]]));
        }
      }

    },

    addPaths: function(list) {

      var i, ii,
          j, jj,
          paths;

      if (list instanceof Array) {
        paths = list;
      }else if (typeof(list) === 'string'){
        paths = [ list ];
      }

      for (i=0,ii=paths.length;i<ii;i++) {
        if (this.properties.hasOwnProperty(paths[i]) && this.properties[paths[i]]) {
          if (this.properties[paths[i]] instanceof Array && this.properties[paths[i]].length) {
            for (j=0,jj=this.properties[paths[i]].length;j<jj;j++) {
              this.paths.push(this.properties[paths[i]][j].replace(/\/(.*?)/g, "$1"));
            }
          }else if (typeof(this.properties[paths[i]]) === 'string') {
            this.paths.push(this.properties[paths[i]].replace(/^\/(.*)/g, "$1"));
          }
        }
      }

    },

    getPath: function() {
      return (this.paths instanceof Array && this.paths.length) ? '/' + this.paths.join('/') : '';
    },

    getQuery: function() {
      return (this.q instanceof Array && this.q.length) ? '?' + this.q.join('&') : '';
    }

  };

  return QueryStringBuilder;

}]);